function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "we_chat",
  "data-name": "we chat"
}, React.createElement("rect", {
  id: "background",
  fill: "#2dc100",
  height: 176,
  rx: 24,
  width: 176
}), React.createElement("g", {
  id: "Icon",
  fill: "#fff"
}, React.createElement("path", {
  d: "m95.3 48h.12c-30.67-17.35-68.87 6.83-61.49 35.35 2 8.46 7.84 15.55 14.93 20.28-1.37 3.91-2.67 7.81-3.91 11.74 4.46-2.34 8.93-4.79 13.4-7.18a49.07 49.07 0 0 0 16.76 2.39c-7-20.2 11-41.61 37.69-39.7-1.99-9.81-8.86-18.11-17.5-22.88zm-36.19 22.24a5.8 5.8 0 1 1 5.8-5.8 5.8 5.8 0 0 1 -5.8 5.8zm27.59 0a5.8 5.8 0 1 1 5.8-5.8 5.8 5.8 0 0 1 -5.8 5.8z"
}), React.createElement("path", {
  d: "m126.71 77c-29.25-14.86-62.5 12.44-47.29 37.5 7 11.76 23.34 19.2 42.62 13.61 3.85 1.51 7.29 3.94 11 5.74-1-3.26-2-6.47-3.11-9.67 19.95-14.18 15.6-37.6-3.22-47.18zm-28.41 19.8a4.48 4.48 0 1 1 4.48-4.48 4.48 4.48 0 0 1 -4.48 4.48zm22 0a4.48 4.48 0 1 1 4.48-4.48 4.49 4.49 0 0 1 -4.48 4.48z"
}))));

var SvgWechat = function SvgWechat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 176 176",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWechat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wechat.a9cf6efa.svg";
export { ForwardRef as ReactComponent };